export const DEV_API_URL = "http://localhost/pswt/pswt-backend";
export const API_URL = "https://members.pswtunion.co.za/api";
export const MODE = process.env.NODE_ENV || 'development';
export const BASE_URL = MODE === 'development' ? DEV_API_URL : API_URL;
